import React from "react";
import Tag from "./Tag";
import { Row } from "antd";

class Tags extends React.Component {
  render() {
    return (
      <Row className="tag-input__tags">
        {this.props.tags.map((el) => {
          return (
            <Tag
              key={el.id}
              id={el.id}
              data={el}
              color={this.props.color}
              removeTag={this.props.removeTag}
              tagIndicator={this.props.tagIndicator}
              isWebhook={this.props.isWebhook}
              channel_type={this.props.channel_type}
            />
          );
        })}
      </Row>
    );
  }
}

export default Tags;
